import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  CargoUnidad,
  Unidad,
  GastoComun,
  IniciarPagoRequest,
  IniciarPagoResponse,
  Pago,
} from '@condo/contracts';
import { ApiRoutes } from '@condo/contracts';
import { api } from '@/lib/api/client';
import { queryKeys } from '@/lib/api/query-keys';

export interface CargoConContexto extends CargoUnidad {
  unidad?: Unidad;
  gastoComun?: GastoComun;
}

interface MisCargosResponse {
  items: CargoConContexto[];
}

export function useMisCargos() {
  return useQuery({
    queryKey: queryKeys.misCargos(),
    queryFn: () => api.get<MisCargosResponse>(ApiRoutes.misCargos),
  });
}

export function useIniciarPago() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      cargoId,
      body,
    }: {
      cargoId: string;
      body: IniciarPagoRequest;
    }) =>
      api.post<IniciarPagoResponse, IniciarPagoRequest>(
        ApiRoutes.iniciarPagoCargo(cargoId),
        body,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.misCargos() });
    },
  });
}

export function useConfirmarPagoMock() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      pagoId,
      outcome,
    }: {
      pagoId: string;
      outcome: 'aprobado' | 'rechazado';
    }) =>
      api.post<Pago, { pagoId: string; outcome: 'aprobado' | 'rechazado' }>(
        ApiRoutes.pagoWebhookMock,
        { pagoId, outcome },
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.misCargos() });
      void qc.invalidateQueries({ queryKey: ['condo', 'dashboard'] });
    },
  });
}
